import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * PATCH `/mom/work-order/{id}/remark`。任意狀態。
 * body：`remark`、`updatedAt`。
 */
export async function updateWorkOrderRemark(id, payload) {
  const { data: raw } = await request.patch(
    `/mom/work-order/${id}/remark`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
